import type { ReactElement, ReactNode } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import { Dashboard } from './pages/Dashboard';
import { ClientDetail } from './pages/ClientDetail';
import { SessionDetailPage } from './pages/SessionDetail';

function Shell({ children }: { children: ReactNode }): ReactElement {
  const { me } = useAuth();
  const loc = useLocation();
  const onDashboard = loc.pathname === '/';
  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/" className="brand">
          <img className="brand-logo" src="/opsrev-logo.png" alt="OpsRev" />
          <span className="brand-sub">Audit</span>
        </Link>
        <nav className="topnav">
          <Link to="/" className={onDashboard ? 'active' : ''}>
            Clients
          </Link>
        </nav>
        <div className="topbar-spacer" />
        <div className="user-chip" title={me.email}>
          <span className="user-name">{me.user.name ?? me.email}</span>
          <a className="link-muted" href="/api/auth/logout">
            Sign out
          </a>
        </div>
      </header>
      <main className="app-main">{children}</main>
    </div>
  );
}

function NotFound(): ReactElement {
  return (
    <div className="card narrow">
      <h1>Not found</h1>
      <p className="muted">That page doesn’t exist.</p>
      <Link className="btn" to="/">
        Back to clients
      </Link>
    </div>
  );
}

export function App(): ReactElement {
  return (
    <AuthProvider>
      <Shell>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clients/:id" element={<ClientDetail />} />
          <Route path="/sessions/:id" element={<SessionDetailPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Shell>
    </AuthProvider>
  );
}
